export enum EllipseEnum {
  big,
  default,
  auth,
}

export interface EllipseProps {
  type: EllipseEnum
}
